export default __webpack_public_path__ + "static/github-f11021803f68852df2837bb05bc7cc0a.png";